module.exports = __webpack_public_path__ + "static/media/treasure.aa075902.wav";